// The api revision header every dashboard request sends. The API treats 3 or lower as
// the old store app (old-client handling of locked inspection entries), and a
// missing header as newest. Never lower this to 3 or below. Contract: api docs
// 2026-10-22-ir-old-store-app-locked-entries-spec.md, section 7.
export const API_REVISION = 4;
